<template>
  <chicklet
    v-if="status"
    :color="status.color"
    :is-uppercase="true"
    :size="size"
    :max-width="maxWidth"
    :type="type"
    :title="status.name"
    class="status-chicklet"
  >
    <span>{{ status.name }} <template v-if="count !== null">({{ count }})</template></span>
  </chicklet>
</template> 

<script lang="ts">
import { IItemStatus, IStatusForSelection } from '@/api/types/response.types'
import { defineComponent } from 'vue'

import chicklet from './chicklet.vue'

export default defineComponent({
  name: 'StatusChicklet',

  components: {
    chicklet,
  },

  props: {
    status: {
      type: Object as () => IStatusForSelection | IItemStatus,
      required: true,
    },
    /* Optionally add "count" -- e.g. count of tasks with this status in the kanban board */
    count: {
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: 'tiny',
    },
    type: {
      type: String,
      default: 'flat',
    },
    maxWidth: {
      type: String,
      default: null,
    },
  },
})
</script>
